module.exports = __webpack_public_path__ + "img/lv6.3d0452e5.png";